export const cpfMask = (cpf) => {
    if (!cpf) return;
    var num = cpf.replace(/[^\d]/g, ''); //remove todos os caracteres não numéricos
    var len = num.length; //guarda o número de digitos até o momento

    if (len <= 6) {
        cpf = num.replace(/(\d{3})(\d{1,3})/g, '$1.$2');
    } else if (len <= 9) {
        cpf = num.replace(/(\d{3})(\d{3})(\d{1,3})/g, '$1.$2.$3');
    } else {
        cpf = num.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/g, "$1.$2.$3-$4");
    }
    return cpf;
}

export const removeInputMask = (cpf) => {
    if (!cpf || cpf === "") {
        return ""
    } else {
        return cpf.replace(/[^\d]+/g, "");
    }
};
 
export const formatDate = (value) => value && `${value.slice(8, 10)}/${value.slice(5, 7)}/${value.slice(0, 4)}`

export const formatDateISO = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
  
    // Utilizar métodos UTC para evitar o impacto do timezone
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
  
    return `${year}-${month}-${day}`;
};

export const formatDateDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
  
    // Utilizar métodos UTC para evitar o impacto do timezone
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
  
    return `${day}/${month}/${year}`;
};

export const formatDateTime = (dateString) => {
    if (!dateString) return null;
    const isUTC = dateString.endsWith("Z") || dateString.includes("+00:00");
    const date = new Date(dateString);
    const formatter = new Intl.DateTimeFormat("pt-BR", {
      timeZone: isUTC ? "UTC" : undefined, // Usa UTC apenas se a string indicar UTC
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false, // 24h
    });
    return formatter.format(date);
}

export const today = () => new Date().toISOString().slice(0, 10);

export const rowspan = {
    setTd : (value, fieldName) => {
        let cont = 0;
        value.forEach(
            (r) => {
                if (cont > 0) {
                    cont--;
                    r.HIDECOL = true;
                    return;
                }
                value.forEach(
                    (s) => {
                        if (r[fieldName] === s[fieldName]) {
                            cont++;
                        }
                    }
                )
                r.ROWSPAN = cont;
                r.HIDECOL = false;
                cont--;
            }
        )
        return value;
    },
    td : (r, value, styleRowSpan, style) => (r.ROWSPAN > 1) ? <td style={styleRowSpan} rowspan={r.ROWSPAN}>{value}</td> : r.HIDECOL ? "" : <td style={style}>{value}</td>
}
 
export const rowspanv2 = {
    setTd : (value, fieldName, fieldName2, fieldName3) => {
        const newFields = (value, fieldName) => {
            let fieldNameCount = 0;
            value.forEach((r) => {
                if (fieldNameCount > 0) {
                    fieldNameCount--;
                    r['HIDECOL_' + fieldName] = true;
                    return;
                }
                value.forEach((s) => {
                        if (r[fieldName] === s[fieldName]) {
                            fieldNameCount++;
                        }
                })
                r['ROWSPAN_' + fieldName] = fieldNameCount;
                r['HIDECOL_' + fieldName] = false;
                fieldNameCount--;            
            })
            return value;
        }

        const fieldNameUnicos = [...new Set(value.map(item => item[fieldName]))];
        fieldNameUnicos.forEach((s) => {
            let va1 = value.filter((e) => e[fieldName] === s);
            newFields(va1, fieldName)
            newFields(va1, fieldName2)
            newFields(va1, fieldName3)
        })

        return value;
    },
    td : (r, fieldName, value, styleRowSpan, style) => (r['ROWSPAN_' + fieldName] > 1) ? <td style={styleRowSpan} rowspan={r['ROWSPAN_' + fieldName]}>{value}</td> : r['HIDECOL_' + fieldName] ? "" : <td style={style}>{value}</td>
}

export const formatarCEP = (cep) => {
    if ((typeof cep === 'undefined') || (cep === null)) return cep;
    // Deixa apenas o número
    cep = cep.replace(/\D/g, '');
  
    // Aplica a máscara no formato XXXXX-XXX
    if (cep.length > 5) {
      cep = cep.replace(/(\d{5})(\d{1,3})/, '$1-$2');
    }
  
    return cep;
}

// Função para calcular o dígito verificador
const calcularDigito = (base) => {
    let soma = 0;
    for (let i = 0; i < base.length; i++) {
        soma += parseInt(base[i]) * (base.length + 1 - i);
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
};
export const isCpfValid = (cpf) => {
    if (!cpf) return false;
    cpf = cpf.replace(/[^\d]/g, '');
    if (cpf.length !== 11) return false;
    // Verifica se todos os dígitos são iguais (ex: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) return false;
    // Calcula os dois dígitos verificadores
    const base = cpf.slice(0, 9);
    const digito1 = calcularDigito(base);
    const digito2 = calcularDigito(base + digito1);
    // Verifica se os dígitos calculados correspondem aos informados
    return cpf === base + digito1 + digito2;
}
export const horarioPadraoLabelFactory = (horariosDoOrgao, reparatedLines) => {
    if (reparatedLines) {
        return horariosDoOrgao.map(item => {
            return {
                value: item,
                label: `${item.DIAS_SEMANA} das ${item.HORA_INICIO} às ${item.HORA_FIM}`
            }
        })
    }
    return {
        value: horariosDoOrgao,
        label: horariosDoOrgao.map(item => `${item.DIAS_SEMANA} das ${item.HORA_INICIO} às ${item.HORA_FIM}`).join(" + ")
    }    
}

/**
 * Gera um novo array de objetos do tipo [{label, value}] com a relação completa de horários cadastrados no banco sem repetição.
 */
export const horariosPadraoLabelSemRepeticao = (horariosComLabel) => {
    //Remove todas as repetições
    const seen = new Set();
	return horariosComLabel.filter(item => {
        item.value = item.value?.map(({ CODIGO_ORGAO, ...resto }) => resto); //Remove o campo "CODIGO_ORGAO" para não causar confusão já que queremos apenas a relação completa de horários cadastrados no banco agrupados por órgão sem repetição.
		if (seen.has(item.label)) return false;
		seen.add(item.label);
		return true;
	});
}
/*
 * Onde o parametro "timeHoraMinuto" deve obrigatóriamente está no formato HH:mm
 */
export const horaParaMinutos = (timeHoraMinuto) => {
    const [h, m] = timeHoraMinuto.split(':').map(Number);
    return h * 60 + m;
}
/**
 * Esta função é usada para normalizar todos os nomes de propriedade de um objeto para caixa baixa.
 * Ex: obj = {CAMPOA: 'A', CAMPOB: 'B'}; let objNormalizado = normalizeKeys(obj); console.log(objNormalizado); //Resulta em {campoa: 'A', campob: 'B'}
 */
export const normalizeKeys = obj =>
    Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));

/**
 * O parâmetro "date" recebe a data na zona local do browser. 
 * Ex: date = new Date("2025-07-31"); Como a string "2025-07-31" não inclui hora, o javascript assume "2025-07-31T00:00:00.000Z"  ← meia-noite UTC (fuso zero) 
 * Depois, ele converte essa hora UTC para o fuso local do seu navegador/sistema, que no seu caso é GMT-3 (Brasília), resultando em: 30 de julho de 2025 às 21:00 no horário de Brasília.
 * Para obter a data independente de fuso, convertemos para UTC. É o que esta função faz desconsiderando a hora.
 */
export const normalizeUTCDateWithoutTime = date => {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
}

/**
 * Verifica se no array de horários existe conflitos
 */
export const verificaConflitosDeHorarios = (horarios, horario) =>{

    if (horario.DIAS_SEMANA === 'Seg à Sex') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Seg a Sáb') || (h.DIAS_SEMANA === 'Seg a Dom')) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }
    if (horario.DIAS_SEMANA === 'Seg a Sáb') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Seg à Sex') || (h.DIAS_SEMANA === 'Seg a Dom')) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }
    if (horario.DIAS_SEMANA === 'Seg a Dom') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Seg à Sex') || (h.DIAS_SEMANA === 'Seg a Sáb')) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }
    if (horario.DIAS_SEMANA === 'Sábado') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Seg a Sáb') || (h.DIAS_SEMANA === 'Seg a Dom') || (h.DIAS_SEMANA === 'Final de Semana')) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }
    if (horario.DIAS_SEMANA === 'Domingo') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Seg a Dom') || (h.DIAS_SEMANA === 'Final de Semana') ) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }
    if (horario.DIAS_SEMANA === 'Final de Semana') {
        for (const h of horarios){ 
            if ((h.DIAS_SEMANA === 'Sábado') || (h.DIAS_SEMANA === 'Domingo') || (h.DIAS_SEMANA === 'Seg a Sáb') || (h.DIAS_SEMANA === 'Seg a Dom') ) {
                return `${horario.DIAS_SEMANA} das ${horario.HORA_INICIO} às ${horario.HORA_FIM} em conflito com ${h.DIAS_SEMANA} das ${h.HORA_INICIO} às ${h.HORA_FIM}.`;
            }
        }
    }

    return null;
}